var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircuit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.85005,
    y: 3.85078,
    width: 14.3,
    height: 14.3,
    stroke: "#F87B0E",
    strokeWidth: 1.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6959,
    y: 5.775,
    width: 10.45,
    height: 10.45,
    stroke: "#737478",
    strokeWidth: 0.55,
    strokeDasharray: "2.75 2.75"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.47495,
    y: 16.775,
    width: 2.75,
    height: 2.75,
    fill: "white",
    stroke: "#2C3038",
    strokeWidth: 0.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.775,
    y: 16.775,
    width: 2.75,
    height: 2.75,
    fill: "white",
    stroke: "#2C3038",
    strokeWidth: 0.55
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.47495,
    y: 2.47422,
    width: 2.75,
    height: 2.75,
    fill: "white",
    stroke: "#2C3038",
    strokeWidth: 0.55
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.775,
    y: 2.47422,
    width: 2.75,
    height: 2.75,
    fill: "white",
    stroke: "#2C3038",
    strokeWidth: 0.55
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircuit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circuit.61130d03e37363296350ee45e2269d35.svg";